import { User } from "../../shared/lib/types/Types"
import { UserAuthActionTypes, UserAuthTypeAction} from "./userStore"

const initialState: User = {
    userId: '',
    firstName: '',
    lastName: '',
    isAuth: false,
    loading: true,
    error: null,
    nickName: "",
    registrationDate: null,
    birthDay: null,
    email: "",
    position: ""
}

const getUserDataReducer = (state = initialState, action: UserAuthTypeAction): User => {    
    switch (action.type) {
        case UserAuthActionTypes.FETCH_DATA_USER_ACCOUNT_LOGOUT:
            return {isAuth: false, loading: false, error: null, userId: '', firstName: '', lastName: '', nickName: '', registrationDate: null, birthDay: null, email: '', position: ''}
        case UserAuthActionTypes.FETCH_DATA_REQUEST_USER_ACCOUNT:
            return {...state, loading: true, error: null};
        case UserAuthActionTypes.FETCH_DATA_RESPONSE_USER_ACCOUNT:
            return {...state, isAuth: true, loading: false, userId: action.payload.userId, firstName: action.payload.firstName, lastName: action.payload.lastName, nickName: action.payload.nickName, registrationDate: action.payload.registrationDate, birthDay: action.payload.birthDay, email: action.payload.email, position: action.payload.position};
        case UserAuthActionTypes.FETCH_DATA_RESPONSE_USER_ACCOUNT_ERR:
            return {...state, loading: false, error: action.payload};
        default:
            return state;
    }
}

export default getUserDataReducer;